module.exports = __webpack_public_path__ + "img/back-0-n-77c8363c.png";